"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var date_fns_1 = require("date-fns");
var Lockr = __importStar(require("lockr"));
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var storageKey = 'slotOfTheWeekNotification';
var GameOfTheWeek = function (_a) {
    var gameCardPlaceholder = _a.gameCardPlaceholder;
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var _b = (0, react_1.useState)(false), isShow = _b[0], setShow = _b[1];
    var t = (0, next_intl_1.useTranslations)('translation');
    var _c = (0, swr_hooks_1.useGamesByCategories)(), categories = _c.data, isLoading = _c.isLoading;
    var gameData = (0, react_1.useMemo)(function () {
        var _a;
        var games = (_a = categories === null || categories === void 0 ? void 0 : categories.slotoftheweek) === null || _a === void 0 ? void 0 : _a.previewGames;
        return (games === null || games === void 0 ? void 0 : games.length) ? games[0] : null;
    }, [categories]);
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var _d = (0, react_1.useState)(false), isNarrowXl = _d[0], setNarrowXl = _d[1];
    var router = (0, navigation_1.useRouter)();
    (0, react_1.useEffect)(function () {
        var scrollHandler = function () {
            if (Object.keys(breakpoints).length > 0 &&
                window.scrollY > 50 &&
                breakpoints.xl) {
                setNarrowXl(true);
            }
            else {
                setNarrowXl(false);
            }
        };
        document.addEventListener('scroll', scrollHandler, true);
        return function () {
            document.removeEventListener('scroll', scrollHandler);
        };
    }, [breakpoints]);
    var onClose = (0, react_1.useCallback)(function () {
        Lockr.set(storageKey, new Date());
        setShow(false);
    }, []);
    (0, react_1.useEffect)(function () {
        var showRecordFromStorage = Lockr.get(storageKey);
        if (!showRecordFromStorage || !(0, date_fns_1.isToday)(new Date(showRecordFromStorage)))
            setShow(true);
    }, []);
    var playGame = (0, react_1.useCallback)(function (e) {
        if (!isAuth)
            return openSignUp();
        if (!e.target.closest('.close'))
            router.push(generateUrlWithLang("/game/".concat(gameData === null || gameData === void 0 ? void 0 : gameData.slug)));
    }, [gameData, generateUrlWithLang, router, isAuth, openSignUp]);
    if (!isShow || isLoading || !gameData)
        return null;
    if (!breakpoints.mobile)
        return null;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.wrapper, " ").concat(isNarrowXl ? styles_module_scss_1.default.narrow : '') },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.container, onClick: playGame },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.image },
                    react_1.default.createElement(ui_components_1.Image, { src: (0, apps_shared_1.getGameImageURL)(gameData.id), alt: "game of the week", placeholder: gameCardPlaceholder })),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.labelContainer },
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.labelText }, t('weekSLot'))),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.gameTitle }, gameData.title),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.provider }, gameData.provider.title)),
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.closeWrapper, " close") },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.closeBtn, onClick: onClose }))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.gradient }))));
};
exports.default = GameOfTheWeek;
